package com.evoapps.evoshift.viewmodels

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

/**
 * One live job per slot: launching again cancels the previous one. For listeners that follow the
 * selected workplace or roster - started anew on every switch, the old ones would keep writing
 * their own workplace's data into the state.
 */
class JobSlot {
    private var job: Job? = null

    fun launch(scope: CoroutineScope, block: suspend CoroutineScope.() -> Unit) {
        job?.cancel()
        job = scope.launch(block = block)
    }

    /** Stops the running job, if any. */
    fun cancel() {
        job?.cancel()
        job = null
    }
}
